import React, {lazy, useState, useEffect} from "react";
import PropTypes from 'prop-types';
import { PageIntroGraphic } from "../Graphics/Block";
import { useStaticQuery, graphql } from "gatsby"
import { Disclosure, Transition, DisclosureButton, DisclosurePanel } from "@headlessui/react";
import { PlusIcon } from "@heroicons/react/24/outline";
import { GeoDetect, useGeoLocation } from "../../functions/GeoDetect/GeoDetect";
// import LocationMap from "./LocationMap";

const LocationMap = lazy(() => import('./LocationMap'));

function OfficeLocations(
    {
        title,
        introText,
        chart,
        chartColour,
        accentColour,
        introImage,
        introImageLogo,
        introImageFullSize,
        customGraphic,
        tintOverlay
    }) {

    const data = useStaticQuery(graphql`
        query LocationsQuery {
            allStrapiDsLocation (sort: {Order: ASC}) {
                edges {
                node {
                    Address
                    City
                    Latitude
                    Longitude
                    id
                    Icon {
                        url
                    }
                }
                }
            }
        }
    `)

    const [ location, setLocation ] = useState('London');

    const ipLocation = useGeoLocation();

    const getLocation = async () => {
        const domainLocation = GeoDetect();
        const geoLocation = await ipLocation;
        let newLocation = 'London';
        if (domainLocation === 'Hamburg, Germany' || geoLocation.country === 'DE') {
          newLocation = 'Hamburg';  
        } else if (domainLocation === 'New York, US' || geoLocation.country === 'US') {
          newLocation = 'New York';  
        } else if (geoLocation.country === 'AU') {
          newLocation = 'Sydney';  
        }
        setLocation(newLocation);
      }
    
    useEffect(() => {
    getLocation();
    }, [ipLocation.country])

    return (
        <div className="bg-global-300 pb-7 lg:pb-14 -mt-16 pt-16">
            <div className="max-full xl:mx-auto xl:max-w-7xl">
                <div className="flex flex-col-reverse md:flex-row gap-4">
                    <div className="hidden xl:block">
                        {customGraphic ? 
                          <>{customGraphic}</>
                        : <PageIntroGraphic tint={accentColour} image={introImage} imageLogo={introImageLogo} imageFullSize={introImageFullSize} chart={chart} chartColour={chartColour} tintOverlay={tintOverlay} /> }
                        
                    </div>
                    <div className="lg:mt-10 mx-auto">
                        <div className="max-w-xl mb-10 mr-20 lg:mr-0 ml-10">
                            <h2 className={`text-${accentColour}-700 font-title text-[30px] lg:text-[45px] font-semibold mb-[30px]`}>{title}</h2>
                            {/* {introText.map((b, idx) => {
                                return (
                                    <p key={idx} className={`${idx === 0 ? 'text-' + accentColour + '-900' : 'text-global-700 font-light'} tracking-wide font-content text-[15px] mb-[20px]`}>
                                        {b.Paragraph}
                                    </p>
                                )
                            })} */}
                            <div className={`${'main-page-text-' + accentColour} text-[15px] tracking-wide mb-10`} dangerouslySetInnerHTML={{__html: introText}} />  
                        </div>
                        <div className="w-[90%] lg:w-[630px] ml-5 lg:ml-10 z-50">
                                {data?.allStrapiDsLocation?.edges?.map(({node}) => {
                                    node.Address = node?.Address?.replace(/(\r\n|\r|\n)/g, "<br/>")
                                    return (
                                    <Disclosure as="div" key={node.id} className="bg-white p-3 mb-6 rounded shadow z-50" defaultOpen={node.City === location}>
                                        <DisclosureButton className="font-title font-semibold text-lg text-plum-900 w-full">
                                            <div className="flex justify-between  items-center">
                                                <div className="flex items-center">
                                                    <div className="w-[60px]"><img className="mx-auto max-h-[40px]" src={node.Icon?.url} /></div>
                                                    <div className="ml-4 pt-1">{node.City}</div>
                                                </div>
                                                <PlusIcon className="flex items-center h-7 lg:h-10 lg:pt-0 mt-1 lg:-mt-2 ui-open:rotate-90 ui-open:transform ui-open:duration-500 ui-not-open:-rotate-0 rot ui-not-open:transform ui-not-open:duration-500" />
                                            </div>
                                        </DisclosureButton>
                                        <Transition
                                            enter="transition duration-500 ease-out"
                                            enterFrom="transform scale-y-0 origin-top opacity-0"
                                            enterTo="transform scale-y-100 origin-top opacity-100"
                                            leave="transition duration-500 ease-out"
                                            leaveFrom="transform scale-y-100 origin-top opacity-100"
                                            leaveTo="transform scale-y-0 origin-top opacity-0"
                                        >
                                            <DisclosurePanel className="font-light mt-4 text-global-700">
                                                <>
                                                <div className="grid grid-cols-1 lg:grid-cols-2 text-sm lg:text-base ">
                                                <div dangerouslySetInnerHTML={{__html: node.Address}}></div>
                                                    <div className="text-blue-700 mt-4 lg:mt-0">

                                                    </div>
                                                </div>
                                                <div className="w-full h-[200px] mt-6">
                                                    <LocationMap id={node.id} lat={node.Latitude} lng={node.Longitude} city={node.City} address={node.Address} />
                                                </div>
                                                </>
                                                
                                            </DisclosurePanel>
                                        </Transition>
                                    </Disclosure>
                                )})}
                            </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

OfficeLocations.propTypes = {
    title: PropTypes.string.isRequired,
    introText: PropTypes.string.isRequired,
    accentColour: PropTypes.string.isRequired,
    introImage: PropTypes.string.isRequired,
    customGraphic: PropTypes.any,
    ctaLabel: PropTypes.string,
    ctaLink: PropTypes.string
}

export default OfficeLocations;